<template>
  <div class="fp" :style="fpStyle">
    <avue-crud :option="option"
               :data="data"
               :page="page"
               ref="crud"
               @search-change="searchChange"
               @search-reset="refreshChange"
               @size-change="sizeChange"
               @current-change="currentChange"
               @refresh-change="refreshChange"
               :row-style="rowStyle"
               @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button type="danger"
                   icon="el-icon-document"
                   @click="$router.push({path:'/pay-list'})"
                   size="mini">订单管理
        </el-button>
        <el-button type="primary"
                   icon="el-icon-s-order"
                   @click="setFlag"
                   size="mini">开 票
        </el-button>
      </template>
      <template slot-scope="scope"
                slot="menu">
        <el-button type="text"
                   @click="setBuild(scope.row)"
                   size="small">生成授权书
        </el-button>
      </template>
    </avue-crud>
    <auth ref="auth"
          @submit="getList">
    </auth>
  </div>
</template>

<script>
  import {mapState} from 'vuex';
  import Record from '@/util/record'

  export default {
    data() {
      return {
        sliderVisible: true, // 控制slider的显示
        data: [],
        selectlist: [],
        page: {
          currentPage: 1,
          total: 0,
          pageSizes: [10, 30, 50, 100, 200, 1000],
          pageSize: 10
        },
        option: {
          size: 'mini',
          align: "center",
          menuAlign: 'left',
          headerAlign: 'center',
          index: true,
          excelBtn: true,
          selection: true,
          addBtn: false,
          delBtn: false,
          viewBtn: true,
          editBtn: false,
          tip: false,
          column: [{
            width: 120,
            label: '编号',
            prop: 'compid',
            search: true
          }, {
            width: 80,
            label: '金额',
            prop: 'money'
          }, {
            label: '公司名',
            prop: 'mc',
            search: true,
          }, {
            label: '税号',
            prop: 'sh',
          }, {
            width: 180,
            label: '账号',
            search: true,
            prop: "qq"
          }, {
            width: 180,
            label: '日期',
            prop: 'datetime'
          }, {
            label: '备注',
            prop: 'bz'
          }]
        },
      }
    },
    computed: {
      fpStyle() {
        // 根据 sliderVisible 状态返回不同的 padding
        return this.sliderVisible
          ? { padding: '100px 10px 100px 10px' } // 默认 padding
          : { padding: '200px 10px 100px 10px' }; // slider 隐藏时的 padding
      },
      ...mapState(['user','pwd']),
    },
    created () {
      const handleResize = () => {
        this.sliderVisible = window.innerWidth > 768;
      };
      handleResize(); // 确保首次加载时执行
      window.addEventListener('resize', () => {
        this.sliderVisible = window.innerWidth > 768;
        this.$forceUpdate(); // 强制更新视图
      });
    },
    methods: {
      searchChange(params) {
        this.getList(params)
      },
      selectionChange(list) {
        this.selectlist = list;
      },
      setFlag() {
        this.selectlist.forEach(ele => {
          const query = new Record('x_ticket');
          const entity = {};
          entity['id'] = ele.objectId;
          entity['flag'] = 1;
          this.$set(this.data[ele.$index], 'flag', 1);
          query.entity(entity);
          return query.update();
        });
        this.$refs.crud.toggleSelection();
        this.$message.success('设置成功')
      },
      rowStyle({row}) {
        if (!row.flag) {
          return {
            backgroundColor: 'rgba(245,108,108,0.1)'
          }
        }
      },
      setBuild(row) {
        let version = 1;
        if (row.money === "5999") {
          version = 5;
        }
        if (row.money === "6999" || row.money === "7999") {
          version = 6;
        }
        const {href} = this.$router.resolve({
          path: '/sqs',
          query: {
            qq: row.qq,
            id: row.compid,
            name: row.mc,
            date: row.datetime,
            version: version
          }
        })
        window.open(href, '_blank')
      },
      currentChange(val) {
        this.page.currentPage = val;
        this.getList()
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.getList()
      },
      refreshChange() {
        this.data = [];
        this.$message.success('刷新成功')
        this.getList();
      },
      getList(params) {
        if (this.validatenull(this.pwd)) return;
        if (this.user !== 'bladex') return;
        const query = new Record('x_ticket');
        query.count().then(res => {
          this.page.total = res.data;
          const next = (this.page.currentPage - 1) * this.page.pageSize;
          query.limit(this.page.pageSize)
          query.skip(next)
          query.order("-updatedAt");
          //query.order("-compid");
          for (let o in params) {
            //query.equalTo(o, "=", `'${params[o]}'`);
            query.equalTo(o, " like ", `'%${params[o]}%'`);
          }
          return query.find()
        }).then(res => {
          /*res.forEach(ele => {
            ele.bz = "blade授权发票"
          });*/
          const data = res.data;
          data.forEach(d => {
            d.datetime = new Date(d.datetime).Format("yyyy.MM.dd");
          })
          this.data = data;
        });
      }
    },
  }
</script>

<style lang="scss">
  .fp {
    min-height: 700px;
  }

  input[type=number] {
    width: 35px !important;
  }
</style>
